import React, {useCallback} from 'react';
import { useDispatch } from 'react-redux';
import KeydownEnterButton from 'app/components/KeydownEnterButtonComponent';
import CitiesListSelectPopup from 'app/components/CitySelect/CitiesListSelectPopup';
import {showPopup} from 'app/actions/AppActions';
import {arrowIconDownGray} from 'app/constants/IconsConstants';
import classNames from 'classnames';
import { Cinema } from 'app/types/common';

interface IProps {
	isDesktopView: boolean,
	selectButton: Cinema['selectButton']
}

const CinemaSelectComponent = ({
	isDesktopView,
	selectButton,
}: IProps) => {
	const dispatch = useDispatch();
	const cinemaTitle = selectButton.options[0].title;
	const citySelectClasses = classNames('city-select__current-city', {
		'city-select__current-city--mobile': !isDesktopView
	});

	const handleClick = useCallback((event) => {
		event.stopPropagation();

		dispatch(showPopup({
			popupContentNode: <CitiesListSelectPopup className="city-select__popup-content" isOpen={true} cinemaSelect={selectButton} />,
		}));
	}, [selectButton]);

	return (
		<div className="city-select city-select--new" onClick={handleClick}>
			<KeydownEnterButton className="city-select__btn-toggle" onClick={_.noop}>
				<div className="city-select__current-city-info">
					<div className={citySelectClasses}>{cinemaTitle}</div>
				</div>
				<span className="city-select__icon">{arrowIconDownGray}</span>
			</KeydownEnterButton>
		</div>
	);
};

export default CinemaSelectComponent;
